// Grouping label for docs with neither a company nor a tag. Lives here rather than in
// @utils/doc so leaf modules can use it without pulling in the service layer.
export const unassignedDocGroupName = 'Unassigned Documents';

export const docTypes = {
  '6K': '6-K',
  '8K': '8-K',
  '10K': '10-K',
  '10Q': '10-Q',
  '20F': '20-F',
  '40F': '40-F',

  EARNINGS: 'Earnings Call Transcript',
  USER_EARNINGS: 'Uploaded Earnings Call Transcript',
  CONFERENCE_TRANSCRIPTS: 'Conference Transcript',
  LENDER_CALL: 'Lender Call',

  NEWS_ARTICLE: 'News Article',

  MELIUS_COMPANY_REPORT: 'Melius Company Report',
  MELIUS_INDUSTRY_REPORT: 'Melius Industry Report',
  MELIUS_WEEKLY_VIDEO_SLIDES: 'Melius Weekly Video Slides',
  MELIUS_INDUSTRIAL_STRATEGY: 'Melius Industrial Strategy',
};

export const earningsDocTypes = [docTypes.EARNINGS, docTypes.USER_EARNINGS, docTypes.CONFERENCE_TRANSCRIPTS];

export const VIEWABLE_DOC_TYPES = [docTypes.EARNINGS];

export const DOCUMENT_SELECTION_MODES = {
  website: 'website',
  docType: 'docType',
  speaker: 'speaker',
  companyTag: 'companyTag',
  client: 'client',
  fedDoc: 'fedDoc',
  myDocs: 'myDocs',
  customMode: 'customMode',

  ppm: 'ppm',
  credit: 'credit',

  allCompany: 'allCompany',

  userCsv: 'userCsv',
};

export const FOLLOW_UP_QUESTION_IDENTIFIER = '**Follow Up**';

export const MANUAL_DOCUMENT_SELECTION_OPTION = 'Select Documents Manually';

export const DOCUMENT_TEMPLATE_MODE_IDS = {
  peer_benchmarking_template: 'peer_benchmarking_template',
  quarterly_data_template: 'quarterly_data_template',
  financial_statement_template: 'financial_statement_template',
  generic_memo: 'generic_memo',
  quick_look: 'quick_look',
  new_deal_triage: 'new_deal_triage',
  new_deal_evaluation: 'new_deal_evaluation',
  growth_equity_memo_template: 'growth_equity_memo_template',
  investment_memo_template: 'investment_memo_template',
  portfolio_snapshot_template: 'portfolio_snapshot_template',
  earnings_grid_template: 'earnings_grid_template',
  portfolio_monitoring_template: 'portfolio_monitoring_template',
  ddq_template: 'ddq_template',
  doc_template_processor: 'doc_template',
};

export const FED_DOC_TYPE_MODES = [
  'Federal Reserve Board (Fed) Release',
  'Federal Reserve Board (Fed) Testimony',
  'Federal Reserve Board (Fed) Speech',
  'Federal Reserve Board (Fed) FOMC Press Conference',
  'Federal Reserve Board (Fed) FOMC Meeting Transcript',
  'Federal Reserve Board (Fed) FOMC Minutes',
  'Federal Reserve Board (Fed) FOMC Statement',
  'Federal Reserve Board (Fed) FOMC Implementation Note',
  'Federal Reserve Board (Fed) FOMC Consensus Statement',
  'Federal Reserve Board (Fed) FOMC Balance Sheet Policy',
  'Federal Reserve Board (Fed) FOMC Memo',
  'Federal Reserve Board (Fed) Beige Book',
  'Federal Reserve Bank of Kansas City Speech',
  'Federal Reserve Bank of Atlanta Speech',
  'Federal Reserve Bank of San Francisco Speech',
  'Federal Reserve Bank of St. Louis Speech',
  'Federal Reserve Bank of Boston Speech',
  'Federal Reserve Bank of Cleveland Speech',
  'Federal Reserve Bank of Richmond Speech',
  'Federal Reserve Bank of New York Speech',
  'Federal Reserve Bank of Dallas Speech',
  'Federal Reserve Bank of Minneapolis Speech',
  'Federal Reserve Bank of Chicago Speech',
  'Federal Reserve Bank of Philadelphia Speech',
];

export const DOC_TYPE_14A = [
  'Uploaded PREC14A',
  'Uploaded DEFA14A',
  'Uploaded DEFC14A',
  'Uploaded DFAN14A',
  'Uploaded DEF 14A',
  'Uploaded PREM14A',
  'Uploaded PRER14A',
  'Uploaded PRE 14A',
  'Uploaded DEFR14A',
  'Uploaded DEFM14A',
  'Uploaded DFRN14A',
  'Uploaded PRRN14A',
];

export const EDGAR = [
  'Uploaded 10-K',
  'Uploaded 10-Q',
  'Uploaded 8-K',
  'Uploaded 20-F',
  'Uploaded 40-F',
  'Uploaded 6-K',
  'Uploaded S-1',
  'Uploaded PREC14A',
  'Uploaded DEFA14A',
  'Uploaded DEFC14A',
  'Uploaded DFAN14A',
  'Uploaded DEF 14A',
  'Uploaded PREM14A',
  'Uploaded PRER14A',
  'Uploaded PRE 14A',
  'Uploaded DEFR14A',
  'Uploaded DEFM14A',
  'Uploaded DFRN14A',
  'Uploaded PRRN14A',
];
